import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';
import If from '@/components/If';
import useUser from '@/hooks/useUser';
import { useNote } from '@components/Note/hooks/useNote';

const SaveCompanyNoteModal = loadable(() => import('../SaveCompanyNoteModal'));

const GuestRegistrationModal = loadable(
  () => import('@/components/GuestRegistrationModal')
);

interface Props {
  companyId?: string;
  uniqueSymbol?: string;
  noteId?: string;
  onClose: () => void;
}

export const CompanyNoteModal = ({
  companyId,
  uniqueSymbol,
  noteId,
  onClose,
}: Props) => {
  const {
    data: { loggedIn },
  } = useUser();
  const { data: note, isFetched } = useNote(noteId as string);

  const { Track, trackEvent } = useTracking({
    type: 'track',
    companyId,
    uniqueSymbol,
  });

  return (
    <Track>
      <If match={!loggedIn}>
        {() => (
          <GuestRegistrationModal
            canClose={true}
            removeWindowScroll={true}
            onClose={() => {
              onClose();
              trackEvent({
                type: 'track',
                subject: 'guest registration modal',
                modifier: 'dismissed',
                action: 'click',
              });
            }}
          />
        )}
      </If>
      <If match={loggedIn && (noteId ? isFetched : true)}>
        {() => (
          <SaveCompanyNoteModal
            note={note}
            companyId={companyId}
            uniqueSymbol={uniqueSymbol}
            onClose={onClose}
          />
        )}
      </If>
    </Track>
  );
};
